import type { RouteObject } from "react-router";
import { INVENTORY_SNAPSHOT_SEGMENT } from "@/features/inventory/inventory.paths";
import { InventorySnapshot } from "./InventorySnapshot";

export const inventorySnapshotRoute: RouteObject = {
  path: INVENTORY_SNAPSHOT_SEGMENT,
  element: <InventorySnapshot />,
};
